import React, { useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react-v3";

import { QUERY_PARAMS } from "src/constants/CommonConstants";

export default function FlashBarFromURL() {
  const location = useLocation();
  const urlParams = queryString.parse(location.search);
  const header = urlParams[QUERY_PARAMS.FLASHBAR_HEADER] as string;
  const type = urlParams[QUERY_PARAMS.FLASHBAR_TYPE] as FlashbarProps.Type;
  const [flashbarItems, setFlashbarItems] = useState([
    {
      type,
      header,
      dismissible: true,
      onDismiss: () => setFlashbarItems([]),
    },
  ]);

  if (!header) {
    return <></>;
  }
  return <Flashbar items={flashbarItems}></Flashbar>;
}
